export default __webpack_public_path__ + "static/media/ST2-V_150_E.1d32e3fb.png";